import { parseYenInput } from '../taxNumberInput';

/** `parseYenInput` にフォールバックを付けた整数読み（税試算フォーム） */
export function parseYenIntLoose(raw: string, fallback: number): number {
  return parseYenInput(raw) ?? fallback;
}

/** カンマ除去後に Number（社保フォームの率・金額など小数あり） */
export function parseInputNumber(el: HTMLInputElement | null, fallback: number): number {
  const raw = String(el?.value ?? '').replace(/,/g, '');
  const v = Number(raw);
  return Number.isFinite(v) ? v : fallback;
}
